import axiosInstance from "./axiosInstance";
//import { store } from '../util/reducer';

//cotitular=1 es para dar de alta un cotitular
//referido=1 es para dar de alta un titular que fue referido por otro titular
const obtenerTitulares = async (id, coTitular = 0, referido = 0) => {
  // store.dispatch({ type: 'SET_RESERVATION_UNABLE' });
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerTitulares?id=${id}&coTitular=${coTitular}&referido=${referido}`,
    { withCredentials: true }
  );
};

export default obtenerTitulares;
